import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { getNotificationListThunk } from '../thunks/notificationThunk';

const notificationSlice = createSlice({
    name: 'notification',
    initialState: {
        notificationList: "",
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getNotificationListThunk.fulfilled, (state, action) => {
                state.notificationList = action.payload?.data;
            })
    },
});

// export const { logout } = messageSlice.actions;

export default notificationSlice.reducer;
